const acceptedStatuses = [
  {
    statusName: 'pending',
    iconName: 'hourglass-half',
    iconColor: 'warning',
    iconClasses: ['animation-spinning']
  },
  {
    statusName: 'success',
    iconName: 'check-circle',
    iconColor: 'success'
  },
  {
    statusName: 'error',
    iconName: 'times-circle',
    iconColor: 'danger'
  }
];


export { acceptedStatuses };